module.exports = __webpack_public_path__ + "media/images/emblems/Chavannes-le-Veyron-coat_of_arms-02057ba5322ab281eb62f7e1e02287c2.svg";